var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 46,
    viewBox: "0 0 610 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 19.3152L25.0647 10.6576L49.2753 2L73.4129 10.6576L97.5506 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5506 19.3152L121.688 10.6576L145.826 2L169.964 10.6576L194.101 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.101 19.3152L218.239 10.6576L242.377 2L266.587 10.6576L290.725 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.725 19.3152L314.862 10.6576L339 2L363.138 10.6576L387.275 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.275 19.3152L411.413 10.6576L435.551 2L459.688 10.6576L483.826 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.826 19.3152L507.964 10.6576L532.174 2L556.312 10.6576L580.449 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.449 19.3152L604.587 10.6576L628.725 2L652.862 10.6576L677 19.3152",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 46.0001L25.0647 37.3424L49.2753 28.6848L73.4129 37.3424L97.5506 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5506 46.0001L121.688 37.3424L145.826 28.6848L169.964 37.3424L194.101 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.101 46.0001L218.239 37.3424L242.377 28.6848L266.587 37.3424L290.725 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.725 46.0001L314.862 37.3424L339 28.6848L363.138 37.3424L387.275 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.275 46.0001L411.413 37.3424L435.551 28.6848L459.688 37.3424L483.826 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.826 46.0001L507.964 37.3424L532.174 28.6848L556.312 37.3424L580.449 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.449 46.0001L604.587 37.3424L628.725 28.6848L652.862 37.3424L677 46.0001",
    stroke: "#6385FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWave);
export default __webpack_public_path__ + "static/media/blue-wave.3fd2c954413401c9059212710be06d02.svg";
export { ForwardRef as ReactComponent };